







  import React, { useState, useEffect, useCallback } from "react";
  import { useNavigate } from "react-router-dom";
  import APIConfig from "../../Common/Configurations/APIConfig";
  import Navbar from "../../Navigation/Navbar";
  import Swal from "sweetalert2";
  import { 
    Eye, Pencil, Trash2, X, Plus, 
    Search, ChevronLeft, ChevronRight, Phone, Mail, Map,
    FileText, Upload, Loader2, CheckCircle, Trash,
    CreditCard, Save, RotateCcw, Layout, Landmark, Info
  } from "lucide-react";

  const MemberList = () => {
    const navigate = useNavigate();
    const [members, setMembers] = useState([]);
    const [loading, setLoading] = useState(true);
    
    const [inputValue, setInputValue] = useState("");
    const [searchTerm, setSearchTerm] = useState("");

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const pageSize = 10;

    // --- DOCUMENT MODAL STATE ---
    const [isDocModalOpen, setIsDocModalOpen] = useState(false);
    const [activeMember, setActiveMember] = useState(null);
    const [memberDocs, setMemberDocs] = useState([]);
    const [docsLoading, setDocsLoading] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [newDocName, setNewDocName] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);

    
  // --- RECEIPT MODAL STATE ---
    const [isReceiptModalOpen, setIsReceiptModalOpen] = useState(false);
    const [receiptMember, setReceiptMember] = useState(null);
    const [plots, setPlots] = useState([]);
    const [savingReceipt, setSavingReceipt] = useState(false);
    const [receiptFormData, setReceiptFormData] = useState({
      plotId: "",
      receiptNo: "", // Added for receipt tracking
      amountPaid: "",
      paymentDate: new Date().toISOString().split("T")[0],
      paymentType: "Installment",
      paymentMethod: "Cash",
      transactionReference: "",
      bankName: "",
      remarks: ""
    });

    const fetchMembers = useCallback(async () => {
      setLoading(true);
      try {
        const url = `${APIConfig.APIACTIVEURL}${APIConfig.MEMBER_GET_ALL}?pageNumber=${currentPage}&pageSize=${pageSize}&searchTerm=${searchTerm}`;
        const response = await fetch(url);
        const result = await response.json();
        setMembers(result.data || []);
        setTotalPages(result.totalPages || 1);
      } catch (e) {
        console.error("Fetch Error:", e);
      }
      setLoading(false);
    }, [currentPage, searchTerm]);

    useEffect(() => {
      fetchMembers();
    }, [fetchMembers]);

    const handleSearchClick = () => {
      setSearchTerm(inputValue);
      setCurrentPage(1);
    };

    const handleClearSearch = () => {
      setInputValue("");
      setSearchTerm("");
      setCurrentPage(1);
    };

    const handleDelete = async (id) => {
      Swal.fire({
        title: 'Are you sure?',
        text: "Permanent delete for this record!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#ef4444',
        confirmButtonText: 'Yes, Delete'
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const res = await fetch(`${APIConfig.APIACTIVEURL}${APIConfig.MEMBER_BASE}/${id}`, { method: "DELETE" });
            if(res.ok) {
              fetchMembers();
              Swal.fire('Deleted!', 'Record removed.', 'success');
            }
          } catch (err) { Swal.fire('Error', 'Failed to delete.', 'error'); }
        }
      });
    };

    const openDocsModal = async (member) => {
      setActiveMember(member);
      setIsDocModalOpen(true);
      fetchMemberDocs(member.memberId);
    };

    const fetchMemberDocs = async (memberId) => {
      setDocsLoading(true);
      try {
        const res = await fetch(`${APIConfig.APIACTIVEURL}${APIConfig.MEMBER_DOC_GET_BY_MEMBER}/${memberId}`);
        const data = await res.json();
        setMemberDocs(data || []);
      } catch (err) { console.error("Docs load error", err); }
      finally { setDocsLoading(false); }
    };

    const handleUpload = async () => {
      if (!newDocName || !selectedFile) return Swal.fire("Required", "Provide name and file", "warning");
      setUploading(true);
      const formData = new FormData();
      formData.append("MemberId", activeMember.memberId);
      formData.append("DocumentName", newDocName);
      formData.append("File", selectedFile);
      try {
        const res = await fetch(`${APIConfig.APIACTIVEURL}${APIConfig.MEMBER_DOC_UPLOAD}`, { method: "POST", body: formData });
        if (res.ok) {
          Swal.fire("Success", "Uploaded", "success");
          setNewDocName(""); setSelectedFile(null);
          document.getElementById("docFileInput").value = "";
          fetchMemberDocs(activeMember.memberId);
        }
      } catch (err) { Swal.fire("Error", "Upload failed", "error"); }
      finally { setUploading(false); }
    };

    const deleteDoc = async (docId) => {
      const result = await Swal.fire({ title: 'Delete?', icon: 'warning', showCancelButton: true });
      if (result.isConfirmed) {
        try {
          const res = await fetch(`${APIConfig.APIACTIVEURL}${APIConfig.MEMBER_DOC_DELETE}/${docId}`, { method: "DELETE" });
          if (res.ok) fetchMemberDocs(activeMember.memberId);
        } catch (err) { Swal.fire("Error", "Delete failed", "error"); }
      }
    };

    const openReceiptModal = async (member) => {
    setReceiptMember(member);
    
    // Ensure plotId is NEVER null, use empty string instead
    const initialPlotId = (member.memberPlots && member.memberPlots.length > 0) 
      ? member.memberPlots[0].plotId 
      : "";

    setReceiptFormData({
      plotId: initialPlotId || "", 
      receiptNo: `REC-${Math.floor(100000 + Math.random() * 900000)}`,
      amountPaid: "",
      paymentDate: new Date().toISOString().split("T")[0],
      paymentType: "Installment",
      paymentMethod: "Cash",
      transactionReference: "",
      bankName: "",
      remarks: ""
    });
      setIsReceiptModalOpen(true);
      try {
        const plotRes = await fetch(`${APIConfig.APIACTIVEURL}${APIConfig.PLOT_GET_ALL}?pageSize=5000`);
        const plotData = await plotRes.json();
        setPlots(plotData.data || []);
      } catch (err) { console.error("Plot fetch failed", err); }
    };

 const handleReceiptSubmit = async (e) => {
    e.preventDefault();
    setSavingReceipt(true);
    try {
      const payload = { 
        memberId: receiptMember.memberId,
        amount: parseFloat(receiptFormData.amountPaid), // Decimal for C#
        receiptNo: receiptFormData.receiptNo,
        paymentDate: receiptFormData.paymentDate,
        paymentMode: receiptFormData.paymentMethod,     // Backend: PaymentMode
        comments: receiptFormData.remarks,              // Backend: Comments
        status: "SUCCESS"  
      };

       const res = await fetch(`${APIConfig.APIACTIVEURL}${APIConfig.RECEIPT_BASE}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (res.ok) {
        Swal.fire({ title: "Success", text: "Receipt Issued & Balance Updated", icon: "success", timer: 1500, showConfirmButton: false });
        setIsReceiptModalOpen(false);
        // This triggers the fetchMembers() which now calculates from Receipts
        await fetchMembers(); 
      }
    } catch (err) { console.error(err); }
    setSavingReceipt(false);
};


    const styles = {
      container: { padding: "40px", backgroundColor: "#f4f7fe", minHeight: "100vh", fontFamily: "'Inter', sans-serif" },
      searchGroup: { display: "flex", gap: "10px", position: "relative", width: "650px" },
      input: { flex: 1, padding: "12px 45px 12px 45px", borderRadius: "12px", border: "1.5px solid #e2e8f0", outline: "none", fontSize: "14px", backgroundColor:'#fff' },
      searchBtn: { backgroundColor: "#4f46e5", color: "#fff", border: "none", padding: "0 25px", borderRadius: "12px", cursor: "pointer", fontWeight: "700" },
      clearBtn: { backgroundColor: "#fff1f2", color: "#e11d48", border: "1.5px solid #fda4af", padding: "0 25px", borderRadius: "12px", cursor: "pointer", fontWeight: "700", fontSize: "14px" },
      addBtn: { backgroundColor: "#4f46e5", color: "#fff", border: "none", padding: "12px 24px", borderRadius: "12px", cursor: "pointer", fontWeight: "700", display: "flex", alignItems: "center", gap: "8px" },
      card: { backgroundColor: "#fff", borderRadius: "20px", boxShadow: "0 4px 25px rgba(0,0,0,0.05)", overflow: "hidden" },
      badge: { padding: "4px 12px", borderRadius: "8px", fontSize: "11px", fontWeight: "800", backgroundColor: "#fef2f2", color: "#ef4444" },
      actionIcon: (bg, color) => ({ border: 'none', background: bg, color: color, padding: '10px', borderRadius: '10px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }),
      modalOverlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(27, 37, 89, 0.4)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000, backdropFilter: 'blur(8px)' },
      modalContent: { backgroundColor: '#fff', borderRadius: '28px', width: '90%', maxWidth: '780px', padding: '35px', position: 'relative', boxShadow: '0 25px 50px rgba(0,0,0,0.15)', maxHeight: '90vh', overflowY: 'auto' },
      modalLabel: { fontSize: '11px', fontWeight: '800', color: '#a3aed0', textTransform: 'uppercase', marginBottom: '6px', display: 'block' },
      modalInput: { padding: '12px 16px', borderRadius: '12px', border: '1.5px solid #e2e8f0', outline: 'none', fontSize: '14px', color: '#1b2559', width: '100%', boxSizing: 'border-box' }
    };

    return (
      <>
        <Navbar />
        <div style={styles.container}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "40px" }}>
            <div>
              <h2 style={{ fontSize: "32px", fontWeight: "900", color: "#1b2559", margin: "0 0 10px 0", letterSpacing: '-0.5px' }}>Members</h2>
              <div style={styles.searchGroup}>
                <Search size={18} style={{ position: "absolute", left: "15px", top: "14px", color: "#a3aed0" }} />
                <input 
                  style={styles.input} 
                  placeholder="Search Member Name, Phone, Plot..." 
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && handleSearchClick()}
                />
                <button style={styles.searchBtn} onClick={handleSearchClick}>Find Member</button>
                <button style={styles.clearBtn} onClick={handleClearSearch}>Clear</button>
              </div>
            </div>
            <button style={styles.addBtn} onClick={() => navigate("/members/manage")}>
              <Plus size={20} /> Add New Member
            </button>
          </div>

          <div style={styles.card}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ backgroundColor: "#f8fafc", color: "#a3aed0", fontSize: "11px", fontWeight: "800", textTransform: "uppercase", borderBottom: "1.5px solid #f1f5f9" }}>
                  <th style={{ padding: "20px", textAlign: "left" }}>Member Info</th>
                  <th style={{ padding: "20px", textAlign: "left" }}>Contact Details</th>
                  <th style={{ padding: "20px", textAlign: "left" }}>Plot Details</th>
                  <th style={{ padding: "20px", textAlign: "left" }}>Financial Status</th>
                  <th style={{ padding: "20px", textAlign: "center" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan="5" style={{ padding: "80px", textAlign: "center", color: "#a3aed0", fontSize: '18px' }}>Syncing with Server...</td></tr>
                ) : members.length === 0 ? (
                  <tr><td colSpan="5" style={{ padding: "80px", textAlign: "center", color: "#a3aed0" }}>No matching members found.</td></tr>
                ) : members.map((m) => {
  // FINANCIAL LOGIC
  const totalPlot = m.balanceAmount || 0; // Total plot value
  const totalPaid = m.paidAmount || 0;    // Sum of receipts (from your backend fix)
  const balance = totalPlot - totalPaid;   // Deduction result

               return (
    <tr key={m.memberId} style={{ borderBottom: "1px solid #f4f7fe" }}>
      <td style={{ padding: "22px 20px" }}>
        <div style={{ fontWeight: "800", color: "#1b2559", fontSize: '15px' }}>{m.memberName}</div>
        <div style={{ fontSize: "12px", color: "#a3aed0", marginTop: '4px', fontWeight: '600' }}>{m.city || "N/A"}, {m.postCode || ""}</div>
      </td>
      <td style={{ padding: "22px 20px" }}>
        <div style={{ fontSize: "13px", display: 'flex', alignItems: 'center', gap: '8px', color: '#475569', fontWeight: '600' }}><Phone size={14} color="#4f46e5" /> {m.phoneNo || "N/A"}</div>
        <div style={{ fontSize: "13px", display: 'flex', alignItems: 'center', gap: '8px', color: '#475569', marginTop: '8px' }}><Mail size={14} color="#4f46e5" /> {m.email || "No Email"}</div>
      </td>
      <td style={{ padding: "22px 20px" }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
          {m.memberPlots && m.memberPlots.length > 0 ? (
            m.memberPlots.map((mp, idx) => (
              <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: '6px', fontWeight: '700', color: '#1b2559', fontSize: '10px' }}>
                <Map size={12} color="#6366f1" />
                {mp.plot.plotNumber} / {mp.plot.project?.projectName || 'N/A'}
              </div>
            ))
          ) : (
            <div style={{ fontSize: '11px', color: '#a3aed0', fontWeight: '600' }}>No Plot Assigned</div>
          )}
        </div>
      </td>
      <td style={{ padding: "22px 20px" }}>
        <div style={{ fontSize: "12px", color: "#64748b", marginBottom: "4px", fontWeight: '700' }}>Total Plot: <span style={{ color: '#1b2559', fontWeight: '800' }}>₹{totalPlot.toLocaleString()}</span></div>
        <div style={{ fontSize: "12px", color: "#64748b", marginBottom: "8px", fontWeight: '700' }}>Total Paid: <span style={{ color: '#059669', fontWeight: '800' }}>₹{totalPaid.toLocaleString()}</span></div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontSize: "11px", color: "#a3aed0", fontWeight: "800" }}>Balance</span>
          <div style={{ 
            ...styles.badge, 
            backgroundColor: balance <= 0 ? '#dcfce7' : '#fef2f2', 
            color: balance <= 0 ? '#059669' : '#ef4444' 
          }}>
            ₹{balance.toLocaleString()}
          </div>
        </div>
      </td>
      <td style={{ padding: "22px 20px" }}>
        <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
          <button title="Issue Receipt" onClick={() => openReceiptModal(m)} style={styles.actionIcon('#dcfce7', '#059669')}><FileText size={18} /></button>
          <button title="Manage Documents" onClick={() => openDocsModal(m)} style={styles.actionIcon('#f5f3ff', '#8b5cf6')}><FileText size={18} /></button>
          <button title="Full View" onClick={() => window.open(`/members/view/${m.memberId}`, "_blank")} style={styles.actionIcon('#eff6ff', '#3b82f6')}><Eye size={18} /></button>
          <button title="Edit Record" onClick={() => navigate(`/members/manage?id=${m.memberId}`)} style={styles.actionIcon('#eef2ff', '#6366f1')}><Pencil size={18} /></button>
          <button title="Remove Member" onClick={() => handleDelete(m.memberId)} style={styles.actionIcon('#fef2f2', '#ef4444')}><Trash2 size={18} /></button>
        </div>
      </td>
    </tr>
  );
})}
              </tbody>
            </table>

            <div style={{ padding: "25px", display: "flex", justifyContent: "space-between", alignItems: "center", borderTop: "1.5px solid #f1f5f9", backgroundColor: '#fcfdfe' }}>
              <span style={{ fontSize: "14px", color: "#a3aed0", fontWeight: '700' }}>Page <span style={{color:'#4f46e5'}}>{currentPage}</span> of {totalPages}</span>
              <div style={{ display: "flex", gap: "12px" }}>
                <button disabled={currentPage === 1} onClick={() => setCurrentPage(c => c - 1)} style={{ padding: "10px 20px", borderRadius: "12px", border: "1.5px solid #e2e8f0", background: "#fff", cursor: currentPage === 1 ? "not-allowed" : "pointer", display: 'flex', alignItems: 'center', gap: '5px', fontWeight: '800', color: '#1b2559' }}><ChevronLeft size={18}/> Prev</button>
                <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(c => c + 1)} style={{ padding: "10px 20px", borderRadius: "12px", border: "1.5px solid #e2e8f0", background: "#fff", cursor: currentPage === totalPages ? "not-allowed" : "pointer", display: 'flex', alignItems: 'center', gap: '5px', fontWeight: '800', color: '#1b2559' }}>Next <ChevronRight size={18}/></button>
              </div>
            </div>
          </div>
        </div>

        {/* --- DOCUMENT MODAL --- */}
        {isDocModalOpen && (
          <div style={styles.modalOverlay}>
            <div style={styles.modalContent}>
              <button onClick={() => setIsDocModalOpen(false)} style={{ position: 'absolute', right: '25px', top: '25px', background: '#f4f7fe', border: 'none', cursor: 'pointer', color: '#94a3b8', padding: '8px', borderRadius: '10px' }}><X size={24} /></button>
              <div style={{display:'flex', alignItems:'center', gap:'12px', marginBottom: '25px'}}>
                  <div style={{background: '#4f46e5', color:'#fff', padding: '12px', borderRadius: '15px'}}><FileText size={24}/></div>
                  <div>
                    <h3 style={{ fontSize: '22px', fontWeight: '900', color: '#1b2559', margin: 0 }}>Documents</h3>
                    <p style={{fontSize: '13px', color:'#a3aed0', fontWeight: '600'}}>Managing files for: {activeMember?.memberName}</p>
                  </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr auto', gap: '15px', marginBottom:'30px', background: '#f8fafc', padding: '20px', borderRadius: '20px', border: '1.5px dashed #cbd5e1' }}>
                  <div style={{flex:1}}><label style={styles.modalLabel}>File Name</label><input type="text" placeholder="e.g. Aadhar Card" style={styles.modalInput} value={newDocName} onChange={(e) => setNewDocName(e.target.value)} /></div>
                  <div style={{flex:1}}><label style={styles.modalLabel}>Select File</label><input id="docFileInput" type="file" style={{...styles.modalInput, padding:'9px'}} onChange={(e) => setSelectedFile(e.target.files[0])} /></div>
                  <button onClick={handleUpload} style={{...styles.searchBtn, alignSelf: 'flex-end', height: '48px'}} disabled={uploading}>{uploading ? <Loader2 className="animate-spin" /> : <Upload size={22} />}</button>
              </div>
              <div style={{ maxHeight: '300px', overflowY: 'auto', paddingRight: '5px' }}>
                  {memberDocs.length === 0 ? <div style={{textAlign:'center', color:'#a3aed0', padding:'20px'}}>No documents uploaded yet.</div> : memberDocs.map((d) => (
                    <div key={d.documentId} style={{ display: 'flex', justifyContent: 'space-between', padding: '16px', background: '#fff', border: '1px solid #f1f5f9', borderRadius: '15px', marginBottom: '10px', alignItems: 'center' }}>
                      <div style={{display:'flex', alignItems:'center', gap: '12px'}}>
                          <FileText size={20} color="#6366f1"/>
                          <span style={{fontWeight:'700', color: '#1b2559'}}>{d.documentName}</span>
                      </div>
                      <div style={{display:'flex', gap:'12px'}}>
                        <a href={`${APIConfig.APIACTIVEURL.replace('/api', '')}/${d.filePath}`} target="_blank" rel="noreferrer" style={{padding: '8px', background: '#e0f2fe', borderRadius: '10px'}}><Eye size={18} color="#0ea5e9"/></a>
                        <button style={{padding: '8px', background: '#fee2e2', border: 'none', borderRadius: '10px', cursor:'pointer'}} onClick={() => deleteDoc(d.documentId)}><Trash size={18} color="#ef4444"/></button>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        )}

        {/* --- PAYMENT MODAL --- */}
      {/* --- RECEIPT MODAL --- */}
        {isReceiptModalOpen && receiptMember && (
          <div style={styles.modalOverlay}>
            <div style={styles.modalContent}>
              <button onClick={() => setIsReceiptModalOpen(false)} style={{ position: 'absolute', right: '25px', top: '25px', background: '#f4f7fe', border: 'none', color: '#94a3b8', padding: '8px', borderRadius: '10px', cursor:'pointer' }}><X size={24} /></button>
              <div style={{display:'flex', alignItems:'center', gap:'12px', marginBottom: '30px'}}>
                  <div style={{background: '#059669', color:'#fff', padding: '12px', borderRadius: '15px'}}><FileText size={24}/></div>
                  <div>
                    <h3 style={{ fontSize: '22px', fontWeight: '900', color: '#1b2559', margin: 0 }}>Generate Receipt</h3>
                    <p style={{fontSize: '13px', color:'#a3aed0', fontWeight: '600'}}>Member: {receiptMember.memberName}</p>
                  </div>
              </div>
              <form onSubmit={handleReceiptSubmit}>
                <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'20px'}}>
                  <div>
                      <label style={styles.modalLabel}>Receipt Number</label>
                      <input type="text" style={{...styles.modalInput, backgroundColor:'#f8fafc'}} value={receiptFormData.receiptNo} readOnly />
                  </div>
                  <div>
                      <label style={styles.modalLabel}>Select Member Plot</label>
                      <select style={styles.modalInput} value={receiptFormData.plotId} onChange={(e) => setReceiptFormData({...receiptFormData, plotId: e.target.value})} required>
                          <option value="">Select Plot...</option>
                          {receiptMember.memberPlots && receiptMember.memberPlots.map(mp => (
                            <option key={mp.plotId} value={mp.plotId}>{mp.plot.plotNumber} - {mp.plot.project?.projectName}</option>
                          ))}
                      </select>
                  </div>
                  <div>
                      <label style={styles.modalLabel}>Amount Received (₹)</label>
                      <input type="number" style={styles.modalInput} value={receiptFormData.amountPaid} onChange={(e) => setReceiptFormData({...receiptFormData, amountPaid: e.target.value})} placeholder="0.00" required />
                  </div>
                  <div>
                      <label style={styles.modalLabel}>Receipt Date</label>
                      <input type="date" style={styles.modalInput} value={receiptFormData.paymentDate} onChange={(e) => setReceiptFormData({...receiptFormData, paymentDate: e.target.value})} required />
                  </div>
                  <div>
                      <label style={styles.modalLabel}>Payment Method</label>
                      <select style={styles.modalInput} value={receiptFormData.paymentMethod} onChange={(e) => setReceiptFormData({...receiptFormData, paymentMethod: e.target.value})}>
                          <option value="Cash">Cash</option>
                          <option value="Bank Transfer">Bank Transfer</option>
                          <option value="UPI">UPI / Digital</option>
                          <option value="Cheque">Cheque</option>
                      </select>
                  </div>
                  <div>
                      <label style={styles.modalLabel}>Reference / Cheque No.</label>
                      <input type="text" style={styles.modalInput} value={receiptFormData.transactionReference} onChange={(e) => setReceiptFormData({...receiptFormData, transactionReference: e.target.value})} placeholder="Optional" />
                  </div>
                  <div style={{gridColumn:'span 2'}}>
                      <label style={styles.modalLabel}>Receipt Remarks</label>
                      <input type="text" style={styles.modalInput} value={receiptFormData.remarks} onChange={(e) => setReceiptFormData({...receiptFormData, remarks: e.target.value})} placeholder="Notes to appear on receipt..." />
                  </div>
                </div>
                <button type="submit" disabled={savingReceipt} style={{...styles.searchBtn, width:'100%', marginTop:'35px', padding:'16px', fontSize: '16px', backgroundColor: '#059669'}}>
                  {savingReceipt ? <Loader2 className="animate-spin" size={20}/> : <CheckCircle size={20} style={{marginRight:'8px'}}/>} 
                  Save & Generate Official Receipt
                </button>
              </form>
            </div>
          </div>
        )}
      </>
    );
  };

  export default MemberList;
